<script lang="ts">
  import { api } from '$shared/api';

  let email = $state('');
  let submitted = $state(false);
  let error = $state('');
  let loading = $state(false);

  async function handleSubmit(e: Event) {
    e.preventDefault();
    if (!email.trim()) return;
    loading = true;
    error = '';
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      submitted = true;
    } catch {
      error = 'Something went wrong. Please try again.';
    }
    loading = false;
  }
</script>

<div class="forgot-wrapper">
  <div class="forgot-card">
    <h2>Reset Password</h2>
    {#if submitted}
      <p class="success-msg">If that email exists, a reset link has been sent.</p>
      <a href="#/login" class="btn btn-primary full-width">Back to Login</a>
    {:else}
      <form onsubmit={handleSubmit}>
        <label class="field">
          <span class="field-label">Email</span>
          <input class="input" type="email" bind:value={email} required autocomplete="email" />
        </label>
        {#if error}<p class="msg--error">{error}</p>{/if}
        <button type="submit" class="btn btn-primary full-width" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
      <p class="back-link"><a href="#/login">Back to Login</a></p>
    {/if}
  </div>
</div>

<style>
  .forgot-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
  }
  .forgot-card {
    max-width: 400px;
    width: 100%;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 2.5rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
  }
  .forgot-card h2 {
    text-align: center;
    color: var(--text);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 0.5rem;
    -webkit-text-fill-color: var(--text);
    background: none;
    background-clip: unset;
    -webkit-background-clip: unset;
  }
  .field {
    display: block;
  }
  .field-label {
    display: block;
    font-size: 0.875rem;
    color: var(--text-muted);
    margin-bottom: 0.25rem;
  }
  .full-width {
    width: 100%;
    padding: 0.625rem;
  }
  .input {
    max-width: 100%;
  }
  .success-msg {
    color: var(--cyan);
    text-align: center;
    font-size: 0.9375rem;
  }
  .back-link {
    text-align: center;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }
  .back-link a {
    color: var(--cyan);
  }
</style>
